import { PaceNotificationCard } from '@evorait/pace-components';
import { NOTIFICATION_STATUS_CODE } from '@evorait/pace-core';

/** The status codes a notification carries while its cancellation still needs to be confirmed. */
export const CANCELLATION_PENDING_STATUS_CODES = new Set<NOTIFICATION_STATUS_CODE>([
    NOTIFICATION_STATUS_CODE.AVR1,
    NOTIFICATION_STATUS_CODE.AVR2,
    NOTIFICATION_STATUS_CODE.CANC,
]);

export interface DashboardView {
    today: PaceNotificationCard[];
    upcoming: PaceNotificationCard[];
    newAssignments: PaceNotificationCard[];
}
